import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-dynamic-hidden',
  templateUrl: './dynamic-hidden.component.html',
  styleUrls: ['./dynamic-hidden.component.scss']
})
export class DynamicHiddenComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;

  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }

  ngOnInit(): void {
  }

}
